"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ts_data_json_1 = require("ts.data.json");
var timestamp_1 = __importDefault(require("./timestamp"));
exports.default = ts_data_json_1.JsonDecoder.object({
    authorId: ts_data_json_1.JsonDecoder.string,
    createdAt: timestamp_1.default,
    deletedAt: ts_data_json_1.JsonDecoder.nullable(timestamp_1.default),
    description: ts_data_json_1.JsonDecoder.string,
    hasThread: ts_data_json_1.JsonDecoder.boolean,
    mentionedUserIds: ts_data_json_1.JsonDecoder.array(ts_data_json_1.JsonDecoder.string, 'UserId[]'),
    parentId: ts_data_json_1.JsonDecoder.nullable(ts_data_json_1.JsonDecoder.string),
}, 'Comment');
